import React, { useState } from "react";
import { Stack } from "@mui/material";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle.jsx";
import ThreeWayMatching from "../ThreeWayMatching/ThreeWayMatching.jsx";

export const PayPerUseHome = () => {
  const nextTwmCode = "";
  const [mode, setMode] = useState("main");

  return (
    <div>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={2}
      >
        <HeaderTitle titleText={"Invoice Automation - Sorting & Matching"} />
      </Stack>

      <ThreeWayMatching
        nextTwmCode={nextTwmCode}
        uploadmode={mode}
        onModeChange={setMode}
        isPayPerUse={true}
      />
    </div>
  );
};

export default PayPerUseHome;
